

export default [

    {
        path:'/advanceHome',
        name:'advance-home',
        component: () => import('@/components/Advance/Home.vue'),
    },
    //Farms
    {
        path:'/advanceHome/Farm',
        name:'advance-farm',
        component: () => import('@/components/Advance/Farm/FarmList.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/Farm/CreateFarm',
        name:'advance-createfarm',
        component: () => import('@/components/Advance/Farm/CreateFarm.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/Farm/EditFarm/:id',
        name:'advance-editfarm',
        component: () => import('@/components/Advance/Farm/EditFarm.vue'),
        meta: {
            layout: 'full',
        }
    },
    //End Farms


    //Animals

    {
        path: '/advanceHome/Farm/editanimals/:id',
        name: 'edit-animals',
        component: () => import('@/components/Advance/Farm/EditAnimals.vue'),
        meta: {
            layout: 'full',
        }
    },
    

    //End Animals
    {
        path:'/advanceHome/Users',
        name:'advance-users',
        component: () => import('@/components/Advance/Farm/UserList.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/uploadUser',
        name:'advance-uploaduser',
        component: () => import('@/components/Advance/Farm/UploadUser.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/Advice',
        name:'advance-advice',
        component: () => import('@/components/Advance/Farm/GetAdvice/GetAdvice.vue'),
        meta: {
            layout: 'full',
        }
    },

    // {
    //     path:'/advanceHome/AdviceList',
    //     name:'advance-advicelist',
    //     component: () => import('@/components/Advance/Farm/GetAdvice/Advice.vue'),
    //     meta: {
    //         layout: 'full',
    //     }
    // },
    {
        path:'/advanceHome/AdviceText',
        name:'advance-advicetext',
        component: () => import('@/components/Advance/Farm/GetAdvice/AdviceText.vue'),
        meta: {
            layout: 'full',
        }
    },



//advance DataLog-Route
    {
        path:'/advanceHome/datalog/',
        name:'advance-dataloghome',
        component: () => import('@/components/Advance/DataLog/Home.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/datalog/farm',
        name:'advance-datalogfarm',
        component: () => import('@/components/Advance/Farm/FarmList.vue'),
        meta: {
            layout: 'full',
        }
    },

    // {
    //     path:'/advanceHome/datalog/animals',
    //     name:'advance-animals',
    //     component: () => import('@/components/Advance/DataLog/Animals.vue'),
    //     meta: {
    //         layout:'full',
    //     }
    // },
//advance DataLog-Economics-Route
    {
        path:'/advanceHome/datalog/economics/home',
        name:'advance-economicshome',
        component: () => import('@/components/Advance/DataLog/Economics/Home.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/datalog/economics/productindex',
        name:'advance-productIndex',
        component: () => import('@/components/Advance/DataLog/Economics/ProductIndex.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/advanceHome/datalog/economics/product',
        name:'advance-economicsproduct',
        component: () => import('@/components/Advance/DataLog/Economics/Product.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path: '/advanceHome/datalog/economics/productEdit/:id',
        name: 'advance-productEdit',
        component: () => import('@/components/Advance/DataLog/Economics/ProductEdit.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/datalog/economics/expenseindex',
        name:'advance-expenseIndex',
        component: () => import('@/components/Advance/DataLog/Economics/ExpenseIndex.vue'),
        meta: {
            layout: 'full'
        }
    },
    
    {
        path:'/advanceHome/datalog/economics/expense',
        name:'advance-economicsexpense',
        component: () => import('@/components/Advance/DataLog/Economics/Expense.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path: '/advanceHome/datalog/economics/expenseedit/:id',
        name: 'advance-ExpenseEdit',
        component: () => import('@/components/Advance/DataLog/Economics/ExpenseEdit.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/datalog/economics/animal',
        name:'advance-economicsanimal',
        component: () => import('@/components/Advance/DataLog/Economics/Animal.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/datalog/economics/incometype',
        name:'advance-economicsincometype',
        component: () => import('@/components/Advance/DataLog/Economics/TypeIncome.vue'),
    },
    /*Animals*/
    {
        path:'/advanceHome/Farm/Animals',
        name:'advance-animals',
        component: () => import('@/components/Advance/Farm/Animals.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/advanceHome/AnimalsStatus',
        name:'advanceHome-animals-status',
        component: () => import('@/components/Advance/Farm/AnimalsStatus.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/advanceHome/Animals/Lots',
        name:'advance-lots',
        component: () => import('@/components/Advance/DataLog/Animal/Lots.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/advanceHome/Lots/Animals',
        name:'advance-lots',
        component: () => import('@/components/Advance/DataLog/Animal/AnimalsLots.vue'),
        meta: {
            layout:'full',
        }
    },
    {
        path:'/advanceHome/datalog/animal/home',
        name:'advance-animalhome',
        component: () => import('@/components/Advance/DataLog/Animal/Home.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/datalog/animal/switch',
        name:'advance-animalSwtich',
        component: () => import('@/components/Advance/DataLog/Animal/AnimalSwitch.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/datalog/animal/addAnimal',
        name:'advance-animaladdanimal',
        component: () => import('@/components/Advance/DataLog/Animal/AddAnimal.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/datalog/animal/addAnimalEn',
        name:'advance-animaladdanimalen',
        component: () => import('@/components/Advance/DataLog/Animal/AddAnimalEn.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/datalog/animal/animalCalendar',
        name:'advance-animalcalendar',
        component: () => import('@/components/Advance/DataLog/Animal/AnimalCalendar.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/datalog/animal/animalExit',
        name:'advance-animalexit',
        component: () => import('@/components/Advance/DataLog/Animal/AnimalExit.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/datalog/animal/animalBatch',
        name:'advance-animalbatch',
        component: () => import('@/components/Advance/DataLog/Animal/AnimalBatch.vue'),
        meta: {
            layout: 'full',
        }
    },
    /*End Animals*/
    {
        path:'/advanceHome/datalog/healthweight/home',
        name:'advance-healthweighthome',
        component: ()  => import('@/components/Advance/DataLog/HealthWeight/Home.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/datalog/healthweight/switch',
        name:'advance-healthweightswitch',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/Switch.vue'),
        meta: {
            layout: 'full',
        }
    },
    {
        path:'/advanceHome/datalog/healthweight/health',
        name:'advance-healthweighthealth',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/Health.vue'),
        meta: {
            layout: 'full',
        }
    },

    {
        path:'/advanceHome/datalog/healthweight/health/vaccineIndex',
        name:'advance-healthvaccineIndex',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/VaccineIndex.vue'),
        meta: {
            layout: 'full'
        }
    },
    {
        path:'/advanceHome/datalog/healthweight/health/vaccine',
        name:'advance-healthvaccine',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/Vaccine.vue'),
        meta: {
            layout: 'full'
        }
    },
    {
        path:'/advanceHome/datalog/healthweight/health/VaccinneEdit/:id',
        name:'advance-healthvaccineEdit',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/VaccinneEdit.vue'),
        meta: {
            layout: 'full'
        }
    },
    {
        path:'/advanceHome/datalog/healthweight/health/deworming',
        name:'basic-loaddatadeworming',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/Deworming.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/advanceHome/datalog/healthweight/health/HealthIndex',
        name:'advance-loadHeatlhIndex',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/HealthIndex.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/advanceHome/datalog/healthweight/health/deworming',
        name:'advance-loaddatadeworming',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/Deworming.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/advanceHome/datalog/healthweight/health/dewormingedit/:id',
        name:'advance-dewormingEdit',
        component: () => import('@/components/Basic/DataLog/HealthWeight/Health/DewormingEdit.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/advanceHome/datalog/healthweight/health/TreatmentIndex',
        name:'advance-diseasetreatmentIndex',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/TreatmentIndex.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/advanceHome/datalog/healthweight/health/Treatment',
        name:'advance-diseasetreatment',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/Treatment.vue'),
        meta: {
            layout: 'full'
        }
    },
    {
        path:'/advanceHome/datalog/healthweight/health/TreatmentEdit/:id',
        name:'advance-TreatmentEdit',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/TreatmentEdit.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/advanceHome/datalog/healthweight/health/ExameneIndex',
        name:'advance-healthexameneIndex',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/ExameneIndex.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path:'/advanceHome/datalog/healthweight/health/examene',
        name:'advance-healthexamene',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/Examene.vue'),
        meta: {
            layout: 'full'
        }
    },

    {
        path: '/advanceHome/datalog/healthWeight/health/alert',
        name: 'advance-healthalert',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Health/Alert.vue')
    },

    {
        path: '/advanceHome/datalog/healthWeight/reproduction/home',
        name: 'advance-healthreproductionhome',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Home.vue'),

    },

    {
        path: '/advanceHome/datalog/healthWeight/reproduction/male',
        name: 'advance-healthreproductionmale',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Male/Male.vue'),
    },

    {
        path: '/advanceHome/datalog/healthWeight/reproduction/female',
        name: 'advance-healthreproductionfemale',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Female/Female.vue'),
    },
    {
        path: '/advanceHome/datalog/healthWeight/reproduction/male/dataupload',
        name: 'advance-dataupload',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Male/DataUpload.vue'),

    },
    {
        path: '/advanceHome/datalog/healthWeight/reproduction/female/dataloaddelivery',
        name: 'advance-femaledataloaddelivery',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Female/DataloadDelivery.vue'),

    },
    {
        path:'/advanceHome/datalog/healthWeight/reproduction/female/dataloadabort',
        name: 'advance-femaledataloadabort',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Female/DataloadAbort.vue'),
    },
    {
        path:'/advanceHome/datalog/healthWeight/reproduction/female/datapalpations',
        name:'advance-femaledatapalpations',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Female/DataloadPalpations.vue')
    },
    {
        path:'/advanceHome/datalog/healthWeight/reproduction/female/datainsemination',
        name:'advance-femaledatainsemination',
        component: () => import('@/components/Advance/DataLog/HealthWeight/Reproduction/Female/DataloadInsemination.vue')
    },
    {
        path:'/advanceHome/datalog/healthWeight/milk',
        name:'advance-healthmilkhome',
        component: () => import('@/components/Advance/DataLog/HealthWeight/MilkHome.vue'),
    },
    {
        path:'/advanceHome/datalog/healthWeight/livestock',
        name:'advance-healthlivestockhome',
        component: () => import('@/components/Advance/DataLog/HealthWeight/LivestockUpload.vue'),
    },

    {
        path:'/advanceHome/farm/loadfarm',
        name:'advance-loadFarm',
        component: () => import('@/components/Advance/DataLog/HealthWeight/LoadFarm.vue'),

    },
    /*Infrastructures */
    {
        path:'/advanceHome/datalog/infrastructureHome',
        name:'advance-infrastructurHome',
        component: () => import('@/components/Advance/DataLog/InfrastructureList.vue'),
    },
    {
        path:'/advanceHome/datalog/infrastructure',
        name:'advance-infrastructure',
        component: () => import('@/components/Advance/DataLog/Infrastructure.vue'),
    },
    {
        path:'/advanceHome/datalog/infrastructure/:id',
        name:'advance-infrastructure-edit',
        component: () => import('@/components/Advance/DataLog/InfrastructureEdit.vue'),
    },
    /*End Infrastructures */
    /*Equipment */
    {
        path:'/advanceHome/datalog/equipmentHome',
        name:'advance-equipmentHome',
        component: () => import('@/components/Advance/DataLog/EquipmentList.vue'),
    },
    {
        path:'/advanceHome/datalog/equipment',
        name:'advance-equipment',
        component: () => import('@/components/Advance/DataLog/Equipment.vue'),
    },
    {
        path:'/advanceHome/datalog/equipment/:id',
        name:'advance-equipment-edit',
        component: () => import('@/components/Advance/DataLog/EquipmentEdit.vue'),
    },
    /*End Equipment */
    //Reports
    {
        path:'/advanceHome/Report',
        name:'advance-report',
        component: () => import('@/components/Basic/Report.vue'),
    },
    {
        path:'/advanceHome/ReproductiveState',
        name:'advance-reproductive-state-report',
        component: () => import('@/components/Basic/Reports/Reproductive.vue'),
    },
    {
        path:'/advanceHome/HealthState',
        name:'advance-health-state-report',
        component: () => import('@/components/Basic/Reports/Health.vue'),
    },
    {
        path:'/advanceHome/Productive',
        name:'advance-productive-report',
        component: () => import('@/components/Basic/Reports/Productive.vue'),
    },
    {
        path:'/advanceHome/Economic',
        name:'advance-economic-report',
        component: () => import('@/components/Basic/Reports/Economic.vue'),
    },
    //End Reports
]
